import { render, staticRenderFns } from "./footer-web.vue?vue&type=template&id=997ef46e&scoped=true"
import script from "./footer-web.vue?vue&type=script&lang=js"
export * from "./footer-web.vue?vue&type=script&lang=js"
import style0 from "./footer-web.vue?vue&type=style&index=0&id=997ef46e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "997ef46e",
  null
  
)

export default component.exports